import { useState } from 'react';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useIsomorphicLayoutEffect } from '../hooks/layout-effect.js';

let hasMountedInClient = false;

/**
 * utility component that defers rendering of the children until the client is
 * executed in the browser.
 */
function NoSSR(props) {
  const [isClientSide, setClientSide] = useState(hasMountedInClient);
  useIsomorphicLayoutEffect(() => {
    setClientSide(true);

    // let future mounted components render instantly once we know we're
    // running in a clientside application life cycle
    hasMountedInClient = true;
  }, []);
  return isClientSide ? /*#__PURE__*/jsx(Fragment, {
    children: props.children
  }) : null;
}

export { NoSSR };
//# sourceMappingURL=no-ssr.js.map
